import styled from "styled-components"

export const FeedGalleryItemBlock = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
`

export const FeedGalleryItemImg = styled.img`
  object-fit: cover;
  height: 100%;
`
